import { updateFleetPositionsUseCase } from '@src/main/modules/parameters/application/update/update-fleet-positions.usecase';
import { UpdateFleetPositionsRequest } from '@src/main/modules/parameters/infrastructure/dto/updateFleetPositionsRequest';
import { createFleetHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/FleetHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateFleetPositions = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createFleetHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateFleetPositionsRequest }) => {
      if (!repository) throw new Error('Repository not initialized');
      return await updateFleetPositionsUseCase(id, data, tokenProvider);
    },
  });
};
